module.exports = __webpack_public_path__ + "static/media/perk-1-new.087b45de.jpg";